import { render, staticRenderFns } from "./EditSaturdayShift.vue?vue&type=template&id=b45803b6&scoped=true"
import script from "./EditSaturdayShift.vue?vue&type=script&lang=js"
export * from "./EditSaturdayShift.vue?vue&type=script&lang=js"
import style0 from "./EditSaturdayShift.vue?vue&type=style&index=0&id=b45803b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45803b6",
  null
  
)

export default component.exports